<div class="app-shell">
  @if (showShell()) {
    <app-navigation-rail></app-navigation-rail>
  }

  <div class="app-shell__content">
    <main class="app-shell__main" [class.app-shell__main--flush]="hideShell()">
      <router-outlet />
    </main>

    @if (showShell()) {
      <app-footer class="mt-auto"></app-footer>
    }
  </div>
</div>